import apiClient from '@/services/api'

export default {
  async getProjects({ commit }, { query = '' }) {
    try {
      const { data } = await apiClient.post('api/search_project', { query })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setProjects', data)
    } catch (error) {
      throw error.message
    }
  },

  async getUsers({ commit, rootState }, { query = '', filter, limit = 20, requestGroup }) {
    const manager_scopes = rootState.applicationState.associate.manager_scopes

    try {
      const { data } = await apiClient.post(
        '/api/associate/search',
        {
          project_id: rootState.applicationState.currentProject.id,
          query: query,
          limit,
          filter: {
            ...filter,
            manager_scopes
          }
        },
        { cancelPreviousRequests: true, requestGroup }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setUsers', data.associates)

      return data.associates
    } catch (error) {
      throw error.message
    }
  },

  async getLegalEntities({ commit, rootState }, { query = '' }) {
    try {
      const { data } = await apiClient.get(
        `/api/project/legal_entity/search?project=${rootState.applicationState.currentProject.id}&name=${query}`
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setLegalEntities', data.items)
    } catch (error) {
      throw error.message
    }
  }
}
